import styled from "@emotion/styled";

export interface SymbolSelectorContainerProps {}

export const SymbolSelectorContainer = styled.div<SymbolSelectorContainerProps>`
  min-width: 141px;
`;
